/**
 * Labstep
 */

import { SortableItemRef } from 'labstep-web/core/Sortable/Item/Ref';
import React from 'react';
import { Table } from 'semantic-ui-react';
import type { ISortableItemProps } from './types';

export const SortableItemTable: RFC<ISortableItemProps> = ({
  children,
  id,
  disabled,
  additionalRows,
}) => (
  <SortableItemRef id={id} disabled={disabled}>
    {({ style }): JSX.Element =>
      additionalRows ? (
        <Table.Body style={style}>
          <Table.Row>{children}</Table.Row>
          {additionalRows}
        </Table.Body>
      ) : (
        <Table.Row key={id} style={style}>
          {children}
        </Table.Row>
      )
    }
  </SortableItemRef>
);
